import * as fromDatatype from "../../../../models/datatype-library";

export class MFACodeValidateDto {
    email?: fromDatatype.VarcharDatatypeInterface;
    code?: fromDatatype.IntegerDatatypeInterface;
  }